// @ts-strict-ignore
import React from 'react';
import Space from 'antd/lib/space';
import {
    AppComponentProps,
    QuickStartCISetupStep,
    QuickStartCISetupStepType,
    QuickStartCISetupViewProps,
} from '../../../typescriptHelpers';
import { InfoTip, setupModuleStyle } from '../../setup/shared';
import { TabletOutlined } from '@ant-design/icons';
import { QuestionsInfoSection } from '../QuestionsInfoSection';
import Form from 'antd/lib/form';
import { AppPlatform } from '../../../types';
import Radio from 'antd/lib/radio';
import { displayTextForAppPlatform } from '../../../helpers/displayHelpers';
import { iconForPlatform } from '../../../helpers/platformComponentHelpers';
import { useDispatch, useSelector } from 'react-redux';
import { setQuickStartCIStepData } from '../../../actions/ui';
import { selectQuickStartCIStepData } from '../../../selectors/selectors';
import { RootState } from '../../../reducers/reducers';

const SetupViewComponent: React.FC<QuickStartCISetupViewProps> = ({ appId }) => {
    const stepData = useSelector((state: RootState) =>
        selectQuickStartCIStepData(state, appId, QuickStartCISetupStepType.PlatformConfirmation),
    );

    const dispatch = useDispatch();

    return (
        <div
            style={{
                ...setupModuleStyle,
            }}
        >
            <Form
                initialValues={{
                    platform: stepData?.platform,
                }}
                onValuesChange={(values) => {
                    dispatch(
                        setQuickStartCIStepData({
                            stepType: QuickStartCISetupStepType.PlatformConfirmation,
                            appId,
                            data: {
                                platform: values.platform,
                            },
                        }),
                    );
                }}
            >
                <div
                    style={{
                        width: '100%',
                        display: 'flex',
                        alignItems: 'flex-end',
                        justifyContent: 'space-between',
                    }}
                >
                    <Form.Item style={{ marginBottom: 0 }} name="platform">
                        <Radio.Group>
                            <Space direction="vertical">
                                {[AppPlatform.Ios, AppPlatform.Android].map((platform) => (
                                    <Radio value={platform} key={platform}>
                                        <Space>
                                            {iconForPlatform(platform)}
                                            {displayTextForAppPlatform(platform)}
                                        </Space>
                                    </Radio>
                                ))}
                            </Space>
                        </Radio.Group>
                    </Form.Item>
                </div>
            </Form>
        </div>
    );
};

const InfoViewComponent: React.FC<AppComponentProps> = () => {
    return (
        <Space direction="vertical">
            <InfoTip>
                Will you be generating builds for iOS or Android? If you ship both platforms, you can run through the
                wizard for each platform one at a time.
            </InfoTip>
            <QuestionsInfoSection />
        </Space>
    );
};

export const PlatformConfirmation: QuickStartCISetupStep = {
    icon: () => TabletOutlined,
    headerTitle: 'Choose your platform.',
    SetupViewComponent,
    InfoViewComponent,
    isCompleteSelector: (state, { appId }) => {
        const stepData = selectQuickStartCIStepData(state, appId, QuickStartCISetupStepType.PlatformConfirmation);
        return !!stepData?.platform;
    },
};
